import { Theme } from './types';

export const themes: Record<string, Theme> = {
  'soft-reds': {
    name: 'Soft Reds',
    colors: {
      primary: '#FF6B9D',
      secondary: '#FFB3C1',
      accent: '#FF8FAB',
      background: 'linear-gradient(135deg, #FFE5EC 0%, #FFC2D1 100%)',
      text: '#8B254A',
      button: '#FF6B9D',
      buttonHover: '#FF8FAB',
      modalBg: 'rgba(255, 235, 236, 0.95)',
      modalBorder: '#FFB3C1',
    },
    fonts: {
      heading: "'Inter', sans-serif",
      body: "'Inter', sans-serif",
    },
  },
  'soft-pinks': {
    name: 'Soft Pinks',
    colors: {
      primary: '#FFABE1',
      secondary: '#FFC2E1',
      accent: '#FFABE1',
      background: 'linear-gradient(135deg, #FFF5F7 0%, #FFE5EC 100%)',
      text: '#C71585',
      button: '#FFABE1',
      buttonHover: '#FFC2E1',
      modalBg: 'rgba(255, 245, 247, 0.95)',
      modalBorder: '#FFC2E1',
    },
    fonts: {
      heading: "'Inter', sans-serif",
      body: "'Inter', sans-serif",
    },
  },
  'glossy-black': {
    name: 'Glossy Black',
    colors: {
      primary: '#2D2D2D',
      secondary: '#1A1A1A',
      accent: '#7B2D5D',
      background: 'linear-gradient(135deg, #1A1A1A 0%, #2D2D2D 100%)',
      text: '#FFFFFF',
      button: '#7B2D5D',
      buttonHover: '#9B4D7D',
      modalBg: 'rgba(45, 45, 45, 0.95)',
      modalBorder: '#7B2D5D',
    },
    fonts: {
      heading: "'Inter', sans-serif",
      body: "'Inter', sans-serif",
    },
  },
};

export const fonts = {
  clean: "'Inter', sans-serif",
  modern: "'Montserrat', sans-serif",
  social: "'Nunito', sans-serif",
};

export const buttonAnimations = {
  pulse: 'pulse 2s infinite',
  bounce: 'bounce 1s infinite',
  glow: 'glow 2s ease-in-out infinite alternate',
  scale: 'scale 0.3s ease-in-out',
};
